// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EyeOutlinedSvg from "@fishx/icons-svg/es/asn/EyeOutlined";
import FishxIcon from '../components/FishxIcon';

var EyeOutlined = function EyeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: EyeOutlinedSvg
  }));
};

EyeOutlined.displayName = 'EyeOutlined';
export default React.forwardRef(EyeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/EyeOutlined.js
// module id = 2660
// module chunks = 0